module.exports = __webpack_public_path__ + "static/media/file-chart-pie.a3c9dbd9.svg";